import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import TippingPage from "./pages/TippingPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import LeaderboardsPage from "./pages/LeaderboardsPage";
import AdminPage from "./pages/AdminPage";
import HistoryPage from "./pages/HistoryPage";
import TipsterProfile from "./pages/TipsterProfile";

// Router wrapper to handle OAuth callback
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (synchronous - prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Public — anyone can browse */}
      <Route path="/" element={<DashboardPage />} />
      <Route path="/dashboard" element={<Navigate to="/" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/tipping/:sport" element={<TippingPage />} />
      <Route path="/leaderboards" element={<LeaderboardsPage />} />
      <Route path="/leaderboard/:sport" element={<LeaderboardPage />} />
      <Route path="/leaderboard/:sport/:competitionId" element={<LeaderboardPage />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/history/:userId" element={<HistoryPage />} />
      <Route path="/tipsters/:userId" element={<ProtectedRoute><TipsterProfile /></ProtectedRoute>} />

      {/* Removed: /register, /competitions (no private comps), public LandingPage */}
      <Route path="/register" element={<Navigate to="/login" replace />} />
      <Route path="/competitions" element={<Navigate to="/" replace />} />
      <Route path="/competitions/:competitionId" element={<Navigate to="/" replace />} />

      {/* Protected — login required */}
      <Route path="/admin" element={
        <ProtectedRoute>
          <AdminPage />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster 
            position="bottom-right"
            toastOptions={{
              style: {
                background: '#FFFFFF',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                color: '#1A1A1A',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
              }
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
